import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import styled from "styled-components";
import ProgressBar from "./components/ProgressBar";
import '../assets/GlobalStyles.css'
import Header from "./components/Header";
import {useEffect, useState} from "react";
import Final from "./steps/Final";

const Wrapper = styled.div`
  padding: 0 16px;

  @media (min-width: 900px) {

  }
`

const Main = () => {

    const [step, setStep] = useState(1)

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        }, [step]
    )

    return <Wrapper>
        <Header/>
        <ProgressBar step={step}/>
        {
            step === 1
                ? <Step1 next={() => setStep(2)}/>
                : step === 2
                    ? <Step2
                        prev={() => setStep(1)}
                        next={() => setStep(3)}/>
                    : step === 3
                        ? <Step3
                            prev={() => setStep(2)}
                            next={() => setStep(4)}/>
                        : <Final/>
        }
    </Wrapper>
}

export default Main
